'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import getCookies from 'commons/getCookies';
import SuspenseWithLoader from '../SuspenseWithLoader';
import ProductListingPagePlaceholder from '../ProductListingPage/ProductListingPagePlaceholder';
import CategoryPageLegacy from './CategoryPageLegacy';
import CategoryPageAlgolia from '../category-page-algolia';
const COOKIE_KEY = 'use-new-category-page';
const getUseAlgoliaFromCookie = () => {
  try {
    const value = getCookies()?.get(COOKIE_KEY);
    return value && String(value).trim() === 'true';
  } catch {
    return false;
  }
};
const stripLeadingAndTrailingSlash = path => {
  const pathWithoutLeadingSlash = path.startsWith('/') ? path.slice(1) : path;
  const pathWithoutTrailingSlash = pathWithoutLeadingSlash.endsWith('/') ? pathWithoutLeadingSlash.slice(0, -1) : pathWithoutLeadingSlash;
  return pathWithoutTrailingSlash;
};
const CategoryPage = t0 => {
  const $ = _c(11);
  const {
    sidebarHeader,
    serverCategoryData
  } = t0;
  const location = useLocation();
  const pathname = location?.pathname || "";
  let t1;
  if ($[0] !== pathname) {
    t1 = stripLeadingAndTrailingSlash(pathname);
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const slug = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = getUseAlgoliaFromCookie();
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const useAlgolia = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ProductListingPagePlaceholder />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== serverCategoryData || $[5] !== sidebarHeader || $[6] !== slug) {
    t4 = useAlgolia ? <CategoryPageAlgolia key={slug} slug={slug} serverCategoryData={serverCategoryData} /> : <CategoryPageLegacy key={slug} sidebarHeader={sidebarHeader} slug={slug} serverCategoryData={serverCategoryData} />;
    $[4] = serverCategoryData;
    $[5] = sidebarHeader;
    $[6] = slug;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== slug || $[9] !== t4) {
    t5 = <SuspenseWithLoader fallback={t3} key={slug}>{t4}</SuspenseWithLoader>;
    $[8] = slug;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
CategoryPage.propTypes = {
  sidebarHeader: PropTypes.node,
  serverCategoryData: PropTypes.object
};
export default CategoryPage;